export enum OrientationTypeEnum {
  NC = 1,
  SP = 2
}
